document.addEventListener('DOMContentLoaded', function () {
  window.formatAllPropertyValues = function () { // Make it globally accessible
    const allPropertyValuesItems = document.querySelectorAll('.sc-all-property-values');

    if (!allPropertyValuesItems.length) {
      console.log('No .sc-all-property-values elements found.');
      return;
    }

    allPropertyValuesItems.forEach(item => {
      const listElement = item.querySelector('.sc-property-values-list');
      if (!listElement) {
        console.warn('No .sc-property-values-list found in:', item);
        return;
      }

      let jsonString = item.getAttribute('data-json-value');
      if (!jsonString) {
        listElement.innerHTML = '<li>No property data</li>';
        console.log('No data-json-value in:', item);
        return;
      }

      try {
        // Ensure JSON is an array
        if (jsonString && !jsonString.startsWith('[')) {
          jsonString = `[${jsonString}]`;
        }

        const jsonData = JSON.parse(jsonString);
        if (Array.isArray(jsonData)) {
          listElement.innerHTML = ''; // Clear existing content
          jsonData.forEach(obj => {
            if (obj.name && obj.value) {
              const li = document.createElement('li');
              // Capitalize each word in the name for nice formatting
              const formattedName = obj.name
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
              li.textContent = `${formattedName}: ${obj.value}`;
              listElement.appendChild(li);
            }
          });
          console.log('Formatted properties:', jsonData);
        } else {
          listElement.innerHTML = '<li>Invalid property data</li>';
          console.warn('Invalid JSON data:', jsonData);
        }
      } catch (e) {
        console.error('JSON parsing error:', e, 'JSON string:', jsonString);
        listElement.innerHTML = '<li>Error parsing properties</li>';
      }
    });
  };

  // Initial run
  window.formatAllPropertyValues();
});